module.exports = "<ng-template #operationConfirm></ng-template>"